export default __webpack_public_path__ + "static/media/icon_plus.5950eb9a.svg";